import React from "react";
import { Controller } from "react-hook-form";

import { cn } from "../../utils/utils";

// Memoized component
const CustomInput = React.memo(
  ({ control, name, label, type, errors, placeholder, className, disabled, tabIndex, required = false }) => {
    return (
      <div className={cn("col-span-2 md:col-span-1 flex flex-col gap-2 ", className)}>
        <label className="text-[14px] md:text-[16px]" htmlFor={name}>
          {label}
        </label>
        <Controller
          control={control}
          name={name}
          // rules={{
          //   required: required && {
          //     value: true,
          //     message: "این فیلد اجباری است ", // Custom required message here
          //   },
          // }}
          render={({ field }) => {
            return (
              <input
                //autoFocus={false}
                tabIndex={tabIndex ? tabIndex : "0"}
                className="h-[52px] text-[14px] md:text-[16px] px-4 outline-none rounded-v-md w-full border border-neutral-30 disabled:bg-neutral-10 disabled:border-none"

                disabled={disabled}
                onChange={(e) => field.onChange(e.target.value)}
                type={type}
                placeholder={placeholder}
                value={field.value} // Ensuring controlled input
              />
            );
          }}
        />
        {errors && <span className="text-red-500 text-sm">{errors?.message}</span>}
      </div>
    );
  },
);

// Add a custom equality function to compare props if needed
const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.control === nextProps.control &&
    prevProps.name === nextProps.name &&
    prevProps.label === nextProps.label &&
    prevProps.type === nextProps.type &&
    prevProps.placeholder === nextProps.placeholder &&
    prevProps.className === nextProps.className &&
    prevProps.disabled === nextProps.disabled &&
    prevProps.tabIndex === nextProps.tabIndex &&
    prevProps.errors === nextProps.errors &&
    prevProps.required === nextProps.required
  );
};

export default React.memo(CustomInput, areEqual);
